import React, { useEffect, useState } from "react";
import ButtonComponent from "../shared/button/button.component";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { ChannelUserModel, mapToChannelUser } from "../../models/users.model";
import { ChannelUserService } from "../../services/ChannelUserService";
import { useDispatch, useSelector } from "react-redux";
import Config from "../../config";
import * as selector from '../../selectors/selectors';
import { Dialog, DialogContent, DialogTitle, Tooltip } from "@mui/material";
import { CancelIcon, LiveChatSuccesfullyConnectedIcon } from "../../icon";
import { LiveChatService } from "../../services/channels/LiveChatService";
import { LoadChannels } from "../../actions";
import axios from "axios";
import { useNavigate } from "react-router";
import { AppRoutes } from "../routes/route.path";
import { ShopifyService } from "../../services/channels/ShopifyService";


interface Iprops {
  HandleNext?: () => void;
  StepData?: any;
}

const EmbeddCode: React.FC<Iprops> = (props: Iprops) => {
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const IsWordPress: boolean = useSelector(selector.IsWordpress)
  const IsShopify: boolean = useSelector(selector.IsShopify)
  const Shopify_Shop: string = useSelector(selector.Shopify_Shop)
  const Shopify_Access_Token: string = useSelector(selector.Shopify_Access_Token)
  const WordPressDomain: string = useSelector(selector.WordPressDomain)

  const [channelId, setChannelId] = useState<string>(props.StepData?.ChannelID);
  const [text, setText] = useState<string>("");
  const [show, setShow] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!!channelId) {
      setText(`
          <script src="${Config.WIDGET_FILE_LINK}?url=${Config.FALKON_CONNECT_APP_URL}/falkon-live-chat/${channelId}" type="text/javascript">
    </script>`)
    }
  }, [channelId])


  const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

  useEffect(() => {
    if (!user.IsWidgetAdded) {
      ChannelUserService.getCurrentUser(user?.Email)
    }
  }, [])


  const handleClick = async () => {
    if (IsWordPress) {
      setIsLoading(true)
      try {
        const response = await fetch(`${WordPressDomain}/wp-json/custom/v1/append-script`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            script: `<script src="${Config.WIDGET_FILE_LINK}?url=${Config.FALKON_CONNECT_APP_URL}/falkon-live-chat/${channelId}" type="text/javascript">
    </script>`,
          }),
        });

        if (response.ok) {
          const result = await response.json();
          console.log('Success:', result);
          LiveChatService.WordpressLiveChatValidation(props.StepData?.ChannelID, { weburl: WordPressDomain }).then((res) => {
            setShow(true)
            setIsLoading(false)
          }).catch((err) => {

          })

        } else {
          console.error('Failed to send script:', response.statusText);
          setIsLoading(false)
        }

      }
      catch (error) {
        console.error('Error:', error);
        alert('An error occurred');
      }
    }
    if (IsShopify) {

      const scriptSrc = `${Config.WIDGET_FILE_LINK}?url=${Config.FALKON_CONNECT_APP_URL}/falkon-live-chat/${channelId}}`;

      ShopifyService.AddLiveChatScript({ shop: Shopify_Shop, script: scriptSrc, access_token: Shopify_Access_Token }).then((res) => {
        if (res.status === 200) {
          LiveChatService.WordpressLiveChatValidation(channelId, { weburl: Shopify_Shop }).then((res) => {
            setShow(true)
            setIsLoading(false)
          })
        }
      }
      )
    }
    else {
      navigator.clipboard.writeText(text);
      setToast("Copied to clipboard Sucessfully!", ToasterType.SUCCESS, "default")
    }
  };

  const handleChannelId = () => {
    props.HandleNext()
  }

  const handleAddLiveChatSucess = () => {
    if (IsWordPress) {
      window.open(WordPressDomain, '_blank');
      setShow(false);
      LoadChannels(dispatch, user.OrganizationID)

    }
    else {
      navigate(AppRoutes.CHANNELS)
      setShow(false);
      LoadChannels(dispatch, user.OrganizationID)
    }
  }


  return (
    <>
      <div className={`add-phone-number-paper-border paper-background h-p-90 m-auto br-2 d-flex flex-direction ${IsWordPress ? "w-p-70" : "w-p-100"}`}>
        <div className={`w-p-85 h-p-10 mx-auto o-hidden my-2 h3-semibold d-flex justify-center align-end color-channel-text-font`}>
          Add this tracking code in the  &lt;body&gt; tag of the web pages you want to integrate
        </div>
        <div className="w-p-85 h-p-75 d-flex justify-center align-center mx-auto h2-medium my-2 channel-embedd-code-border br-1 p-1">
          {text}
        </div>
        <div className=" w-p-85 h-p-15 mx-auto d-flex justify-flex-end">
          {IsWordPress ?
            <span className="d-flex align-center">
              <ButtonComponent ButtonLabel={"ADD To Wordpress Website"} OnClick={handleClick} Variant={"primary-btn"} Loading={isLoading} />
            </span>
            :
            IsShopify ?
              <span className="d-flex align-center">
                <ButtonComponent ButtonLabel={"ADD To Shopify Store"} OnClick={handleClick} Variant={"primary-btn"} Loading={isLoading} />
              </span>
              :
              <span className="d-flex align-center">
                <ButtonComponent ButtonLabel={"Copy"} OnClick={handleClick} Variant={"secondary-btn"} ClassName="mr-3 "></ButtonComponent>
                <ButtonComponent ButtonLabel={"Validate"} OnClick={handleChannelId} Variant={"primary-btn"} ClassName=""></ButtonComponent>
              </span>
          }
        </div>
      </div>
      {
        show &&
        < Dialog
          maxWidth='md'
          open={show}
          onClose={() => { setShow(false) }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: "w-75 h-60 br-2  dialogue-shadow" }}
        >
          <DialogTitle id="alert-dialog-title">
            <div className="h2-semibold color-text-field-font d-flex">
              <Tooltip title='Close' placement='bottom'>
                <span className={"ml-auto"}>
                  <CancelIcon className={"c-pointer"} onClick={() => { setShow(false) }} />
                </span>
              </Tooltip>
            </div>
          </DialogTitle>
          <DialogContent className={` w-p-91 pb-0`}>
            <div className={` paper-background m-auto br-2 d-flex flex-direction `}>
              <div className={` d-flex justify-center align-center`}>
                <LiveChatSuccesfullyConnectedIcon />
              </div>
              <div className="h-p-20 t-align-center d-flex justify-center align-center color-secondary-success h2-semibold">
                Live Chat Successfully Added!
              </div>
              <div className="h-p-20 d-flex justify-center align-center">
                <ButtonComponent ButtonLabel={IsWordPress ? "Go To Wordpress Website" : "Go to More Options"} Variant={"primary-btn"} ClassName="" OnClick={() => handleAddLiveChatSucess()} />
              </div>
            </div>
          </DialogContent>
        </Dialog >
      }

    </>
  )
}

export default EmbeddCode;